import type { Guardrails } from '../../types';

// Conta quantas salvaguardas estão ativas, para o badge de conformidade.
export function countActiveGuardrails(g: Guardrails): number {
  let n = 0;
  if (g.contentFilters.pii) n++;
  if (g.contentFilters.toxicity) n++;
  if (g.contentFilters.jailbreak) n++;
  if (g.contentFilters.blockedTopics.length) n++;
  if (g.redactPII) n++;
  if (g.allowedTools.length) n++;
  if (g.inputSchema) n++;
  if (g.outputFormat === 'json') n++;
  if (g.humanApprovalActions.length) n++;
  if (g.onViolation !== 'warn') n++;
  return n;
}
